const Cross = ({ className = '' }) => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="44" height="44" />
    <path
      d="M31.4012 11.568L32.4324 12.5992L23.0313 21.9999L32.4319 31.4006L31.4007 32.4318L22 23.0312L12.5991 32.4325L11.5679 31.4013L20.9689 21.9999L11.5676 12.5991L12.5988 11.5679L22 20.9689L31.4012 11.568Z"
      fill="black"
    />
  </svg>
);

export default Cross;
